"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnDoubleClick = void 0;
const proj_1 = require("ol/proj");
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function useOnDoubleClick(callback) {
    const callbackRef = react_1.useRef(callback);
    react_1.useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    const map = useOLMap_1.useOLMap();
    react_1.useEffect(() => {
        const onClick = (e) => {
            var _a;
            e.preventDefault();
            (_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackRef, { coordinates: proj_1.toLonLat(e.coordinate) });
        };
        map.on('dblclick', onClick);
        return () => {
            map.un('dblclick', onClick);
        };
    }, [map]);
}
exports.useOnDoubleClick = useOnDoubleClick;
//# sourceMappingURL=useOnDoubleClick.js.map